import React from 'react'

interface Thead extends React.HTMLProps<HTMLTableSectionElement> {
  isHeader?: boolean
  node?: any
}

export const Thead: React.FC<Thead> = ({
  children,
  isHeader,
  node,
  ...props
}) => (
  <thead className="bg-primary-200 dark:bg-primary-700" {...props}>
    {children}
  </thead>
)

export default Thead
